export default __webpack_public_path__ + "static/media/close-grey.f9bce231.svg";